import React from 'react';
import PropTypes from 'prop-types';

import { badges as Badges, buttonsV2 as Buttons } from '@breezeway/brzw-components';

import './filter_toggle_button.scss';

const CLASS_NAME = 'filter-toggle-button';

export const FilterToggleButton = ({ active, className, filtersCount, icon, onClick }) => (
  <Buttons.IconTextButton
    active={active}
    className={`${CLASS_NAME} ${className}`}
    iconNameLeft={icon}
    isLoading={false}
    onClick={onClick}
    size={Buttons.constants.BUTTON_SIZES.MEDIUM}
    theme={Buttons.constants.BUTTON_THEMES.DEFAULT}
  >
    Filter
    {filtersCount > 0 && (
      <Badges.CircledBadge
        className={`${CLASS_NAME}__count`}
        size={Badges.constants.CIRCLED_BADGE_SIZES.MEDIUM}
        text={filtersCount}
        theme={Badges.constants.BADGE_THEMES.COUNTER}
        withoutBorder
      />
    )}
  </Buttons.IconTextButton>
);

FilterToggleButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  filtersCount: PropTypes.number,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

FilterToggleButton.defaultProps = {
  active: false,
  className: '',
  filtersCount: 0,
  icon: 'filter',
  onClick: () => {},
};

export default FilterToggleButton;
